// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"2621e12f","821":"d2640a8c","933":"e5853251"}[chunkId] + ".chunk.css";
};